import React, { useContext } from "react";
import { Box, Grid, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import ConfigContext from "../../common/context/ConfigContext";

export default function CustomItemSummaryTile(props) {
  const siteConfig = useContext(ConfigContext);

  return (
    <Grid item xs={12} sm={6}>
      <Box mb={2}>
        <Link component={RouterLink} to={`/get-quote`} underline="none" sx={{ color: "inherit" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "#ECECEC",
              borderRadius: "3px"
            }}
          >
            <Box p={1} textAlign={"left"}>
              <Typography variant="h5">Custom Cakes</Typography>
              <Typography variant="caption" color="textSecondary">
                Get the cake of your dreams! We specialize in creating custom cakes for any occasion, from birthdays to weddings, tailored to your
                unique vision. Choose from 1000s of designs or upload your own to get a quote.
              </Typography>
            </Box>
            <Box
              p={2}
              sx={{
                minWidth: "150px",
                minHeight: "156px",
                backgroundColor: "#DEDEDE",
                color: "#555",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                flexDirection: "column",
                borderRadius: "3px"
              }}
            >
              <Typography variant="h3" gutterBottom>
                GET A
              </Typography>
              <Typography variant="h3">QUOTE</Typography>
            </Box>
          </Box>
        </Link>
      </Box>
    </Grid>
  );
}
